
import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';
import Overlay from '../Overlay/Overlay.js';
import Modal from 'react-modal';
import DiscountForm from '../DiscountForm/DiscountForm';
import { sendDiscountForm } from '../../utils/api';
import { $qs, buildImageObject } from "../../helpers/misc-javascript-helpers.js";


class BannerSlide extends Component {

	constructor(props) {
		super(props);

		this.state = {
			backgroundImage: '',
			mediaBgImage: '',
			ctaBackgroundColor: '',
			ctaTextColor: '',
			ctaHoverColors: {},
			formFulfilled: false,
			modalIsOpen: false,
			commError: false,
			season: this.props.isSeasonal ? this.props.season : '',
			bgImagePath: this.props.bgImagePath
		};


		this.handleCtaBackgroundMouseOver = this.handleCtaBackgroundMouseOver.bind(this);
		this.handleCtaBackgroundMouseOut = this.handleCtaBackgroundMouseOut.bind(this);

		this.openModal = this._openModal.bind(this);
		this.closeModal = this._closeModal.bind(this);
		this.postDiscountData = this._postDiscountData.bind(this);
	}

	componentDidMount() {
		this.setState({ ctaBackgroundColor: this.props.ctaBackgroundColor });
		this.setState({ ctaTextColor: this.props.ctaTextColor });
		this.setState({ ctaHoverColors: this.props.ctaHoverColors });
		Modal.setAppElement('body');
		/* If the slide is receiving a background image as a prop then run the preload for its images */
		if (this.props.backgroundImage !== null) {
			this.handleBgImagePreload();
		}
	}

	/** Handle the mouse over for cta button colors coming from the parent state, api or json */
	handleCtaBackgroundMouseOver(e) {
		this.setState({ ctaBackgroundColor: this.state.ctaHoverColors.background.hover });
		this.setState({ ctaTextColor: this.state.ctaHoverColors.text.hover });
	}

	/** Handle the mouse out for cta button colors coming from the parent state, api or json */
	handleCtaBackgroundMouseOut(e) {
		this.setState({ ctaBackgroundColor: this.state.ctaHoverColors.background.initial });
		this.setState({ ctaTextColor: this.state.ctaHoverColors.text.initial });
	}

	/** Get the string value for the current screen size using the slides prop - tried using a 
	 * loop like this Object.keys(this.props.mobileMediaStatus[item]) to automate the conditions
	 * but it didn't work. Will try again.
	*/
	handleMediaQueryState() {
		let mediaQueryMessage = '';

		if (this.props.mobileMediaStatus) {
			mediaQueryMessage = 'mobile';
		} else if (this.props.tabletMediaStatus) {
			mediaQueryMessage = 'tablet';
		} else {
			mediaQueryMessage = 'desktop';
		}
		return mediaQueryMessage;
	}

	/** Handle the preloading of the banner image */
	handleBgImagePreload() {
		let slideImages = [];
		let imagePath, season, screenSize, fullImageName, imageName = '';

		/* Build each image path for each screen size, for each slide */
		Object.keys(this.props.breakingPoints).forEach(item => {
			imagePath = this.props.bgImagePath;
			imageName = this.props.backgroundImage;
			season = this.props.isSeasonal ? '-' + this.state.season : '';
			screenSize = '-' + item;
			fullImageName = `${imagePath}${imageName}${season}${screenSize}.jpg`;
			slideImages.push(fullImageName);
		});
		/* Build each preloading image object and inject into the DOM via buildImageObject */
		slideImages.forEach((item, index) => {
			$qs('body').appendChild(buildImageObject(item, index, imageName));
		});

		return slideImages;
	}

	/** Open the discount code modal */
	_openModal() {
		this.setState({ modalIsOpen: true });
	}

	/** Close discount code modal */
	_closeModal() {
		this.setState({ modalIsOpen: false });
	}

	async _postDiscountData(discount_form, captcha = null) {

		var response = await sendDiscountForm(captcha, discount_form, 'invisible');
		if (response.data.success) {
			this.setState({ formFulfilled: response.data.success });
		} else {
			this.setState({ formFulfilled: true, commError: true });
		}
		return response;
	}

	formMessage() {
		if (this.state.formFulfilled && !this.state.commError) {
			return (
				<div className="form-msg__block container">
					<div className="row">
						<div className="col-md-12 text-left">
							<p>Use discount code <strong>SKYE20</strong> at checkout.
							This code is valid for 20% off all of your Skye purchases.</p>
						</div>
						<div className="col-md-12 text-center">
							<button name="submit" className="btn btn-mid-orange ubuntu"
								onKeyDown={(e) => {
									e.key === 'Enter' && e.preventDefault() && this.closeModal();
								}}
								onClick={this.closeModal}>
								<span>close</span>
								<div className={'ripple-container'}></div>
							</button>
						</div>
					</div>
				</div>
			);
		} else {
			return (
				<div className="form-msg__block container">
					<div className="text-center" ><div>Sorry we could not process your request. Please refresh the page and try again</div>
						<br /><button name="submit" className="btn btn-mid-orange ubuntu"
							onKeyDown={(e) => { e.key === 'Enter' && e.preventDefault() && this.closeModal(); }}
							onClick={this.closeModal}>
							<span>close</span>
							<div className={'ripple-container'}></div>
						</button></div>
				</div>
			);
		}
	}

	/** Method that returns the Featured Course or Featured Certificate slides */
	getCertOrCourseSlide() {
		return (
			<React.Fragment>
				<div className={(this.props.slideName === 'featuredCourse') ? 'row featured-course' : 'row featured-certificate'}>
					<div className="row banner-slide__inner__row">
						<div className="col-sm-5 col-md-5 col-lg-5">
							<div className="banner-slide__image__wrapper row">
								<div className="banner-slide__content--mobile col-md-12">
									<p className="banner-slide__subheading banner-slide__subheading--mobile" tabIndex="0">{ReactHtmlParser(this.props.subheading)}</p>
									<h2 className="banner-slide__heading banner-slide__heading--mobile h2" tabIndex="0">{ReactHtmlParser(this.props.heading)}</h2>
								</div>
								<div className="col-md-12">
									{this.props.image ? <img className="banner-slide__image fluid" src={this.props.image} alt={'Slide ' + this.props.count + ' course icon'} tabIndex="0" /> : ''}

									<a className="banner-slide__cta banner-slide__cta--mobile trans18s" href={this.props.ctaLink} style={{ backgroundColor: this.state.ctaBackgroundColor }} aria-label={this.props.ariaLabel ? ReactHtmlParser(this.props.ariaLabel) : this.props.heading} tabIndex="0">
										<div className="banner-slide__cta__layer" onMouseOver={(e) => this.handleCtaBackgroundMouseOver(e)} onMouseOut={(e) => this.handleCtaBackgroundMouseOut(e)}></div>
										{ReactHtmlParser(this.props.ctaText.text) ? <span className="trans18s" style={{ color: this.state.ctaTextColor }} >{ReactHtmlParser(this.props.ctaText.text)}</span> : ''}
									</a>
								</div>
							</div>
						</div>
						<div className="col-sm-7 col-md-7 col-lg-7 banner-slide__content--desktop">
							<p className="banner-slide__subheading banner-slide__subheading--desktop" tabIndex="0">{ReactHtmlParser(this.props.subheading)}</p>
							<h2 className="banner-slide__heading h2 banner-slide__heading--desktop" tabIndex="0">{ReactHtmlParser(this.props.heading)}</h2>
							<p className="banner-slide__description" tabIndex="0">{ReactHtmlParser(this.props.content)}</p>
							<a className="banner-slide__cta trans18s" href={this.props.ctaLink} style={{ backgroundColor: this.state.ctaBackgroundColor }} aria-label={this.props.ariaLabel ? ReactHtmlParser(this.props.ariaLabel) : this.props.heading} tabIndex="0">
								<div className="banner-slide__cta__layer" onMouseOver={(e) => this.handleCtaBackgroundMouseOver(e)} onMouseOut={(e) => this.handleCtaBackgroundMouseOut(e)}></div>
								{this.props.ctaText.otherText ? <span className="trans18s" style={{ color: this.props.ctaTextColor }}>{ReactHtmlParser(this.props.ctaText.otherText)}</span> : ''}
								{this.props.ctaText.text ? <span className="trans18s" style={{ color: this.state.ctaTextColor }} >{ReactHtmlParser(this.props.ctaText.text)}</span> : ''}
							</a>
						</div>

					</div>
					<div className="mw-100 w-100">
						<div className="banner-slide__control__dots col-md-12"></div>
					</div>
					<Overlay theClass="banner-slide__overlay" theState={''} theStyle={this.props.opacity ? this.props.opacity : null}></Overlay>
					<div className="banner-slide__bg"></div>
				</div>
			</React.Fragment>
		);
	}

	render() {

		const modalStyles = {
			content: {
				top: '50%',
				left: '50%',
				right: 'auto',
				bottom: 'auto',
				marginRight: '-50%',
				transform: 'translate(-50%, -50%)',
				width: '500px',
				maxWidth: '80%',
				border: 'dotted 1px',
			}
		};

		return (
			<div className="banner-slide__block">

				{/* If the slide is for Skye Has No Limit */}
				{this.props.slideName === 'discountCode' ?
					<React.Fragment>
						<div className={'row ' + 'discount-code'}>
							<div className="row banner-slide__inner__row">
								<div className="col-sm-4 col-md-4 col-lg-4">
									<h2 className="banner-slide__heading h2" tabIndex="0">{ReactHtmlParser(this.props.heading)}</h2>
								</div>
								<div className="col-sm-4 col-md-4 col-lg-4">
									<button className={'banner-slide__cta trans18s'} style={{ backgroundColor: this.state.ctaBackgroundColor }} onClick={this.openModal}>
										<div className="banner-slide__cta__layer" onMouseOver={(e) => this.handleCtaBackgroundMouseOver(e)} onMouseOut={(e) => this.handleCtaBackgroundMouseOut(e)}></div>
										{this.props.ctaText.otherText ? <span className="trans18s" style={{ color: this.props.ctaTextColor }}>{this.props.ctaText.otherText}</span> : ''}
										{this.props.ctaText.text ? <span className="trans18s" style={{ color: this.state.ctaTextColor }}>{this.props.ctaText.text}</span> : ''}
									</button>
								</div>
								<div className="col-sm-4 col-md-4 col-lg-4">
									<p className="banner-slide__content" tabIndex="0">{this.props.content}</p>
								</div>
								<div className="banner-slide__control__dots col-md-12"></div>
							</div>
							<Overlay theClass="banner-slide__overlay" theState={''} theStyle={this.props.opacity ? this.props.opacity : null}></Overlay>
							<div className="banner-slide__bg" style={{ backgroundImage: `url(${this.state.bgImagePath}${this.props.backgroundImage}-${this.state.season}-${this.handleMediaQueryState()}.jpg)` }}></div>
						</div>
					</React.Fragment>
					: ''}

				<React.Fragment>
					<Modal
						isOpen={this.state.modalIsOpen}
						onRequestClose={this.closeModal}
						shouldCloseOnOverlayClick={false}
						style={modalStyles}
						contentLabel="Flash Sale Form"
					>
						{(!this.state.formFulfilled) ?
							<DiscountForm submitAction={this.postDiscountData} cancelAction={this.closeModal} /> : this.formMessage()}
					</Modal>
				</React.Fragment>

				{/* If the slide is for Blog of The Week */}
				{this.props.slideName === 'blogOfTheWeek' ?
					<React.Fragment>
						<div className={'row ' + 'blog-of-week'}>
							<div className="row banner-slide__inner__row">
								<div className="col-sm-12 col-md-12 col-lg-12">
									<p className="banner-slide__subheading text-center" tabIndex="0">{ReactHtmlParser(this.props.subheading)}</p>
								</div>
								<div className="col-sm-12 col-md-12 col-lg-12">
									<h2 className="banner-slide__heading h2 text-center" tabIndex="0">{ReactHtmlParser(this.props.heading)}</h2>
									<p className="banner-slide__author text-center" tabIndex="0">By {this.props.author}</p>
								</div>
								<div className="col-sm-12 col-md-12 col-lg-12">
									<a className={'banner-slide__cta bx-shadow trans18s'} href={this.props.ctaLink} target="_blank" aria-label={ReactHtmlParser(this.props.heading) } style={{ backgroundColor: this.state.ctaBackgroundColor }} rel="noopener">
										<div className="banner-slide__cta__layer" onMouseOver={(e) => this.handleCtaBackgroundMouseOver(e)} onMouseOut={(e) => this.handleCtaBackgroundMouseOut(e)}></div>
										{this.props.ctaText.otherText ? <span className="trans18s" style={{ color: this.props.ctaTextColor }}>{this.props.ctaText.otherText}</span> : ''}
										{this.props.ctaText.text ? <span className="trans18s" aria-hidden="true" style={{ color: this.state.ctaTextColor }}>{this.props.ctaText.text}</span> : ''}
									</a>
								</div>
								<div className="banner-slide__control__dots col-md-12"></div>
							</div>
							<Overlay theClass="banner-slide__overlay" theState={''} theStyle={this.props.opacity ? this.props.opacity : null}></Overlay>
							<div className="banner-slide__bg" style={{ backgroundImage: `url(${this.state.bgImagePath}${this.props.backgroundImage}-${this.handleMediaQueryState()}.jpg)` }}></div>
						</div>
					</React.Fragment>
					: ''}

				{/* If the slide is for Featured Course or Featured Certificate */}
				{this.props.slideName === 'featuredCertificate' ?
					<React.Fragment>
						{this.getCertOrCourseSlide()}
					</React.Fragment>
					: ''}

				{/* If the slide is for Featured Course or Featured Certificate */}
				{this.props.slideName === 'featuredCourse' ?
					<React.Fragment>
						{this.getCertOrCourseSlide()}
					</React.Fragment>
					: ''}
			</div>
		);
	}
}
export default BannerSlide;